import { z } from 'zod';
import {
    NOTIFICATION_TEMPLATE_CHANNELS,
    NOTIFICATION_TEMPLATE_LOCALES,
    NotificationLocaleVariantsSchema,
} from './notification-template.schema.js';

export const NotificationTemplatePreviewSchema = z.object({
    locale: z.enum(NOTIFICATION_TEMPLATE_LOCALES).default('en'),
    channel: z.enum(NOTIFICATION_TEMPLATE_CHANNELS),
    variables: z.array(z.string().trim().min(1).max(120)).max(100).default([]),
    sampleVariables: z.record(z.string(), z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.null(),
    ])).optional().default({}),
    variant: z.record(z.string(), z.unknown()),
}).strict();

export const NotificationTemplateTestSendSchema = z.object({
    locale: z.enum(NOTIFICATION_TEMPLATE_LOCALES).default('en'),
    channels: z.array(z.enum(NOTIFICATION_TEMPLATE_CHANNELS)).min(1).max(4),
    code: z.string().trim().min(2).max(120).regex(/^[A-Z][A-Z0-9_]*$/).optional(),
    templateId: z.string().trim().min(1).max(120).optional(),
    sampleVariables: z.record(z.string(), z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.null(),
    ])).optional().default({}),
    variants: NotificationLocaleVariantsSchema.optional(),
}).strict().refine((value) => Boolean(value.templateId || value.code || value.variants), {
    message: 'templateId, code, or variants is required for test send',
});
